/* Nejdřív polyfilly — starší Safari na tabletu (viz lib/polyfill.ts). */
import './lib/polyfill.js';
/* Plné úložiště prohlížeče nesmí shodit obrazovku (Tom 1. 11. 2026, QuotaExceededError v Poledním menu). */
import './lib/uloziste-pojistka.js';
import '@rw/design-system/reset.css';
import '@rw/design-system/tokens.css';
import '@rw/design-system/base.css';
import './print.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import { pripravUloziste } from './lib/uloziste-idb.js';

if (import.meta.env.PROD && import.meta.env.VITE_SENTRY_DSN) {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.VITE_SENTRY_ENV ?? 'production',
    tracesSampleRate: 0.1,
  });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1 },
  },
});

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root element not found');

/* Nejdřív místní kopie z IndexedDB (Tom 2. 11. 2026: „lepší si počkat na relevantní data, než aby nám spadl
   prohlížeč"), teprve pak appka — všechny stores si při načtení čtou úložiště synchronně. */
void pripravUloziste().then(async () => {
  const { App } = await import('./App.js');
  ReactDOM.createRoot(rootEl).render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </React.StrictMode>,
  );
});
